import { ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { checkoutApi } from 'Utils/api';
import {
  reserveWatchesRequest,
  reserveWatchesSuccess,
  reserveWatchesFailure,
} from 'Redux/Slices/CheckoutSlice';
import { setReservationExpiry } from 'Redux/Slices/CartSlice';

export const reserveWatchesEpic = (action$: any) =>
  action$.pipe(
    ofType(reserveWatchesRequest.type),
    mergeMap((action: any) =>
      from(checkoutApi.reserveWatches(action.payload)).pipe(
        mergeMap((response) => {
          const expiresAt = new Date(response.data.expiresAt).getTime();
          return of(
            reserveWatchesSuccess(),
            setReservationExpiry(expiresAt)
          );
        }),
        catchError((error) =>
          of(reserveWatchesFailure(error.response?.data?.error || 'Failed to reserve watches'))
        )
      )
    )
  );
